/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Angeringfuegigebeschaeftigung2Inputs */



/**

* @param {_Field_Angeringfuegigebeschaeftigung2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_angeringfuegigebeschaeftigung2 = /** @type {((inputs?: _Field_Angeringfuegigebeschaeftigung2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Angeringfuegigebeschaeftigung2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Geringfügige Beschäftigung")
});
export { _field_angeringfuegigebeschaeftigung2 as "_field_anGeringfuegigeBeschaeftigung" }